import { render, staticRenderFns } from "./SkillView.vue?vue&type=template&id=1c2d6b76&scoped=true&"
import script from "./SkillView.vue?vue&type=script&lang=ts&"
export * from "./SkillView.vue?vue&type=script&lang=ts&"
import style0 from "./SkillView.vue?vue&type=style&index=0&id=1c2d6b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d6b76",
  null
  
)

export default component.exports